import Api from '../Api';

import { url } from './config';
import { PassengerPhones } from './types';

class ExtendedApi extends Api<PassengerPhones> {}

const api = new ExtendedApi(url);

export default api;
